import 'shepherd.js/dist/css/shepherd.css';
import './style.scss';
import Shepherd from 'shepherd.js/dist/esm/shepherd.mjs';

export default Shepherd;